export interface FaqItem {
  question: string;
  answer: string;
}

export const HOME_FAQ: FaqItem[] = [
  {
    question: "How is pricing calculated?",
    answer:
      "Per seat per month, where a seat is one configured agent. You pay the tier fee for the platform plus the headcount you've hired. There are no per-action or per-token surprises — if your agents hit a daily runtime cap we pause them and notify you.",
  },
  {
    question: "Does my data stay private?",
    answer:
      "Yes. Every tenant is isolated at the database level by client_id scoping, reinforced by application middleware. Agents only see the data you grant them and the audit log records every tool call. We never train models on your data.",
  },
  {
    question: "Can agents touch my GitHub?",
    answer:
      "Only if you grant a scoped GitHub App installation. Engineering agents default to opening pull requests as a bot user; merges require your human review. You can revoke access from your workspace settings at any time.",
  },
  {
    question: "How do approvals work?",
    answer:
      "Every high-blast-radius action — merging a PR, sending an external email, charging a customer — waits in an approval queue until a human approves it. Your team decides which categories require approval in the workspace settings.",
  },
  {
    question: "What if I need a role that's not listed?",
    answer:
      "Reach out through the contact form. We're actively building new roles and prioritize based on customer demand. Enterprise plans include custom role builds as part of the contract.",
  },
  {
    question: "Is there a free trial?",
    answer:
      "Starter is $99/month with no commitment — cancel anytime. We don't offer a free trial because real agent work incurs real infrastructure cost, but you can cancel before month two if it isn't working.",
  },
  {
    question: "What about hallucinations on customer-facing work?",
    answer:
      "Customer-facing agent output passes a confidence threshold before auto-send. Below threshold the response drafts into an approval queue. You can tighten or loosen the threshold per agent.",
  },
  {
    question: "Can I bring my own model keys?",
    answer:
      "Enterprise customers can bring their own Vertex AI, OpenAI, or Anthropic keys. Starter and Growth use our managed Vertex AI infrastructure with Claude and Gemini.",
  },
];

export const PRICING_FAQ: FaqItem[] = [
  {
    question: "Can I switch tiers?",
    answer:
      "Yes, up or down, at any time. Upgrades take effect immediately. Downgrades apply at the next billing cycle so you keep what you're paying for through the current month.",
  },
  {
    question: "What counts as an agent?",
    answer:
      "One configured instance of a role. If you hire two Backend Engineers with different prompts, that counts as two agents. A paused agent still counts toward your seat total.",
  },
  {
    question: "Are there usage caps?",
    answer:
      "Starter and Growth have per-agent daily runtime caps to protect against runaway loops. Enterprise plans are uncapped with volume-based pricing negotiated in the contract.",
  },
  {
    question: "Do you offer nonprofit or startup discounts?",
    answer:
      "Yes. Nonprofits and early-stage startups (under 10 employees, under $1M ARR) get 50% off Growth for the first year. Apply via the contact form.",
  },
];
